import React, {   } from 'react';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import Select from 'react-select';

const AccountInfoTab = ({ register, errors, watch, setValue, clearErrors, setError, inputClassName, getCustomerTags ,getReferralSources,getIndustries,getAssignedContracts,getTaxItems,getCurrencies,getAssignedAgents,getPrefixes,getFrequencies}) => {
  const watchPhoneNumbers = watch('primary_contact.phone_numbers') || [];
  const watchEmails = watch('primary_contact.emails') || [];
  const watchServiceLocations = watch('service_locations') || [];
  const watchServiceAgreements = watch('service_agreements') || [];
  const watchAssignedAgentsReps = watch('assigned_agents') || [];
  
  
  // Phone number formatting function
  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const phoneNumber = value.replace(/\D/g, '');
    
    // Limit to 10 digits
    const limitedNumber = phoneNumber.slice(0, 10);
    
    // Format as (xxx) xxx-xxxx
    if (limitedNumber.length <= 3) {
      return limitedNumber;
    } else if (limitedNumber.length <= 6) {
      return `(${limitedNumber.slice(0, 3)}) ${limitedNumber.slice(3)}`;
    } else {
      return `(${limitedNumber.slice(0, 3)}) ${limitedNumber.slice(3, 6)}-${limitedNumber.slice(6, 10)}`;
    }
  };

  // Handle phone number input change
  const handlePhoneNumberChange = (index, value) => {
    const updatedPhones = [...watchPhoneNumbers];
    updatedPhones[index].number = value;
    setValue('primary_contact.phone_numbers', updatedPhones);
  };
  
  const phoneTypeOptions = [
    { value: 'mobile', label: 'Mobile' },
    { value: 'home', label: 'Home' },
    { value: 'work', label: 'Work' },
    { value: 'other', label: 'Other' }
  ];

  const emailTypeOptions = [
    { value: 'Personal', label: 'Personal' },
    { value: 'Work', label: 'Work' },
    { value: 'Other', label: 'Other' }
  ];
 
    const getCommissionTypes = [
      { value: '1', label: '%' },
      { value: '2', label: '$' }
    ]

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      opacity: state.data.value === '' ? 0.5 : 1,
      fontStyle: state.data.value === '' ? 'normal' : 'normal',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.data.value === '' ? 0.5 : 1,
      fontStyle: state.data.value === '' ? 'normal' : 'normal',
    }),
  };

  const addPhoneNumber = () => {
    const currentPhoneNumbers = watch('primary_contact.phone_numbers') || [];
    setValue('primary_contact.phone_numbers', [
      ...currentPhoneNumbers,
      { type: 'mobile', number: '', ext: '' }
    ]);
  };

  const removePhoneNumber = (index) => {
    const currentPhoneNumbers = watch('primary_contact.phone_numbers') || [];
    const updatedPhoneNumbers = currentPhoneNumbers.filter((_, i) => i !== index);
    setValue('primary_contact.phone_numbers', updatedPhoneNumbers);
  };

  const addEmail = () => {
    const currentEmails = watch('primary_contact.emails') || [];
    setValue('primary_contact.emails', [
      ...currentEmails,
      { type: 'Personal', address: '' }
    ]);
  };

  const removeEmail = (index) => {
    const currentEmails = watch('primary_contact.emails') || [];
    const updatedEmails = currentEmails.filter((_, i) => i !== index);
    setValue('primary_contact.emails', updatedEmails);
  };

  const addServiceLocation = () => {
    const currentLocations = watch('service_locations') || [];
    setValue('service_locations', [
      ...currentLocations,
      {
        location_nickname: '',
        is_primary_location: false,
        is_billing_address: false,
        street_address: '',
        apt: '',
        city: '',
        state: '',
        zipcode: '',
        contact: '',
        active: true,
        is_gated_property: false,
        gate_access_instructions: ''
      }
    ]);
  };

  const removeServiceLocation = (index) => {
    const currentLocations = watch('service_locations') || [];
     
    const updatedLocations = currentLocations.filter((_, i) => i !== index);

    setValue('service_locations', updatedLocations);
  };

  const addServiceAgreement = () => {
    const currentAgreements = watch('service_agreements') || [];
    setValue('service_agreements', [
      ...currentAgreements,
      {
        name: '',
        effective_date: '',
        expiration_date: '',
        amount: '',
        frequency: '',
        description: ''
      }
    ]);
  };

  const removeServiceAgreement = (index) => {
    const currentAgreements = watch('service_agreements') || [];
    const updatedAgreements = currentAgreements.filter((_, i) => i !== index);
    setValue('service_agreements', updatedAgreements);
  };

  const addAgentRep = () => {
    const currentAgents = watch('assigned_agents') || [];
    setValue('assigned_agents', [
      ...currentAgents,
      { agent_rep_id: '', commission_type: '', commission: '' }
    ]);
  };

  const removeAgentRep = (index) => {
    const currentAgents = watch('assigned_agents') || [];
    const updatedAgents = currentAgents.filter((_, i) => i !== index);
    setValue('assigned_agents', updatedAgents);
  };

  return (
    <div className="space-y-8">
      {/* Basic Information */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Basic Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('name')}
              className={`${inputClassName} ${errors.name ? 'border-red-500' : ''}`}
              placeholder="Enter customer name"
            />
            {errors.name && (
              <p className="mt-1 text-sm text-red-600">{errors.name.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Parent Account <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('parent_account')}
              className={`${inputClassName} ${errors.parent_account ? 'border-red-500' : ''}`}
              placeholder="Enter parent account"
            />
            {errors.parent_account && (
              <p className="mt-1 text-sm text-red-600">{errors.parent_account.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Account Number <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('account_number')}
              className={`${inputClassName} ${errors.account_number ? 'border-red-500' : ''}`}
              placeholder="Enter account number"
            />
            {errors.account_number && (
              <p className="mt-1 text-sm text-red-600">{errors.account_number.message}</p>
            )}
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('is_vip_account')}
              className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              VIP Account
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('has_service_agreement')}
              className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Has Service Agreement
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('active')}
              className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Active
            </label>
          </div>
        </div>

        {/* Service Agreements - Conditional Section */}
        {watch('has_service_agreement') && (
          <div className="mt-6 bg-white p-4 rounded-lg border border-gray-200">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-md font-medium text-gray-900">Service Agreements</h4>
              <button
                type="button"
                onClick={addServiceAgreement}
                className="flex items-center px-3 py-1 text-sm text-[#009efb] hover:text-[#0089db]"
              >
                <PlusIcon className="w-4 h-4 mr-1" />
                Add Another Agreement
              </button>
            </div>
            {watchServiceAgreements.map((agreement, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Agreement Name
                    </label>
                    <input
                      type="text"
                      {...register(`service_agreements[${index}].name`)}
                      
                      onChange={(e) => {
                         setValue(`service_agreements[${index}].name`, e.target.value);
                      }}
                      className={inputClassName}
                      placeholder="Enter agreement name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Effective Date
                    </label>
                    <input
                      type="text"
                      {...register(`service_agreements[${index}].effective_date`)}
                      onInput={(e) => {
                        setValue(`service_agreements[${index}].effective_date`, e.target.value);
                        
                      }}
                      className={`${inputClassName} ${errors.service_agreements?.[index]?.effective_date ? 'border-red-500' : ''} datepicker`}
                      placeholder="Enter effective date"
                      
                      onChange={(e) => {
                        
                        setValue(`service_agreements[${index}].effective_date`, e.target.value);
                      }}
                     
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Expiration Date
                    </label>
                    <input
                      type="text"
                      {...register(`service_agreements[${index}].expiration_date`)}
                      onInput={(e) => {
                        setValue(`service_agreements[${index}].expiration_date`, e.target.value);
                        
                      }}
                      className={`${inputClassName} ${errors.service_agreements?.[index]?.expiration_date ? 'border-red-500' : ''} datepicker`}
                      placeholder="Enter expiration date"
                      
                      onChange={(e) => {
                        setValue(`service_agreements[${index}].expiration_date`, e.target.value);
                      }}
                      
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Amount $
                      </label>
                      <input
                        type="number"
                        {...register(`service_agreements[${index}].amount`)}
                        
                        onChange={(e) => {
                          setValue(`service_agreements[${index}].amount`, e.target.value);
                        }}
                        className={inputClassName}
                        placeholder="0.00"
                        step="0.01"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Frequency
                      </label>
                      <Select
                        options={[
                          { value: '', label: 'Select Frequency' },
                          ...getFrequencies?.map(option => ({
                            value: option.id,
                            label: option.name
                          }))
                        ]}
                        value={
                          getFrequencies
                            ?.map(option => ({
                              value: option.id,
                              label: option.name
                            }))
                            .find(opt => Number(opt.value) === Number(watch(`service_agreements[${index}].frequency`)))
                        }
                        onChange={(option) => {
                          setValue(`service_agreements[${index}].frequency`, option?.value || '');
                        }}
                        styles={customStyles}
                        placeholder="Select frequency"
                      />

                    </div>
                  </div>

                  <div className="md:col-span-2 lg:col-span-3">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Description/Notes
                    </label>
                    <textarea
                      {...register(`service_agreements[${index}].description`)}
                      onChange={(e) => {
                        setValue(`service_agreements[${index}].description`, e.target.value);
                      }}
                      className={inputClassName}
                      rows="3"
                      placeholder="Enter description/notes"
                    />
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    onClick={() => removeServiceAgreement(index)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <TrashIcon className="w-5 h-5" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Primary Contact */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Primary Contact</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Prefix <span className="text-red-500">*</span>
            </label>
           
            <Select
              options={[
                { value: '', label: 'Select Prefix' },
                ...getPrefixes?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ]}
              value={
                [
                  { value: '', label: 'Select Prefix' },
                  ...getPrefixes?.map(option => ({
                    value: option.id,
                    label: option.name
                  }))
                ].find(opt => Number(opt.value) === Number(watch('primary_contact.prefix_id')))
              }
              onChange={(option) => {
                if(option?.value === ''){
                  setError('primary_contact.prefix_id', {
                    type: 'required',
                    message: 'Prefix is required'
                  });
                  setValue('primary_contact.prefix_id', option?.value || '');
                }else{
                  clearErrors('primary_contact.prefix_id'); 
                  setValue('primary_contact.prefix_id', option?.value || '');
                  clearErrors('primary_contact.prefix_id');
                }
              }}
              styles={customStyles}
              className={`${inputClassName} ${errors.primary_contact?.prefix_id ? 'border-red-500' : ''}`}
              placeholder="Select prefix"
            />

            {errors.primary_contact?.prefix_id && (
              <p className="mt-1 text-sm text-red-600">{errors.primary_contact.prefix_id.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('primary_contact.first_name')}
              className={`${inputClassName} ${errors.primary_contact?.first_name ? 'border-red-500' : ''}`}
              placeholder="Enter first name"
            />
            {errors.primary_contact?.first_name && (
              <p className="mt-1 text-sm text-red-600">{errors.primary_contact.first_name.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              {...register('primary_contact.last_name')}
              className={`${inputClassName} ${errors.primary_contact?.last_name ? 'border-red-500' : ''}`}
              placeholder="Enter last name"
            />
            {errors.primary_contact?.last_name && (
              <p className="mt-1 text-sm text-red-600">{errors.primary_contact.last_name.message}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Suffix
            </label>
            <input
              type="text"
              {...register('primary_contact.suffix')}
              className={`${inputClassName} ${errors.primary_contact?.suffix ? 'border-red-500' : ''}`}
              placeholder="Enter suffix"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Department
            </label>
            <input
              type="text"
              {...register('primary_contact.department')}
              className={`${inputClassName} ${errors.primary_contact?.department ? 'border-red-500' : ''}`}
              placeholder="Enter department"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Job Title
            </label>
            <input
              type="text"
              {...register('primary_contact.job_title')}
              className={`${inputClassName} ${errors.primary_contact?.job_title ? 'border-red-500' : ''}`}
              placeholder="Enter job title"
            />
          </div>
        </div>

        {/* Phone Numbers */}
        <div className="mt-6">
          <div className="flex justify-between items-center  ">
            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Numbers <span className="text-red-500">*</span></label>
            <button
              type="button"
              onClick={addPhoneNumber}
              className="flex items-center px-3 py-1 text-sm text-[#009efb] hover:text-[#0089db]"
            >
              <PlusIcon className="w-4 h-4 mr-1" />
              Add Phone Number
            </button>
          </div>
          {errors.primary_contact?.phone_numbers && typeof errors.primary_contact.phone_numbers === 'string' && (
            <p className="mt-1 text-sm text-red-600 mb-4">{errors.primary_contact.phone_numbers}</p>
          )}
          {watchPhoneNumbers.map((phone, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
              <div>
                <Select
                  {...register(`primary_contact.phone_numbers[${index}].type`)}
                  options={phoneTypeOptions}
                  value={phoneTypeOptions.find(option => option.value === phone.type)}
                  onChange={(option) => {
                    const updatedPhones = [...watchPhoneNumbers];
                    updatedPhones[index].type = option?.value || '';
                    setValue('primary_contact.phone_numbers', updatedPhones);
                  }}
                  
                  placeholder="Type"
                />
                {errors.primary_contact?.phone_numbers?.[index]?.type && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.primary_contact.phone_numbers[index].type.message}
                    </p>
                )}
              </div>
              <div className="relative">
                <input
                  type="tel"
                  {...register(`primary_contact.phone_numbers[${index}].number`)}
                  onChange={(e) => {
                    const formattedValue = formatPhoneNumber(e.target.value);
                    handlePhoneNumberChange(index, formattedValue);
                    if(formattedValue === ''){
                      setError(`primary_contact.phone_numbers[${index}].number`, {
                        type: 'required',
                        message: 'Phone number is required'
                      });
                    }else{
                      clearErrors(`primary_contact.phone_numbers[${index}].number`);
                    }
                  }}
                  className={`${inputClassName} ${errors.primary_contact?.phone_numbers?.[index]?.number ? 'border-red-500' : ''} ${phone.number && phone.number.match(/^\(\d{3}\) \d{3}-\d{4}$/) ? 'border-green-500' : ''}`}
                  placeholder="(555) 123-4567"
                  maxLength="14"
                />
                {phone.number && phone.number.match(/^\(\d{3}\) \d{3}-\d{4}$/) && (
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
                 
                 {errors.primary_contact?.phone_numbers?.[index]?.number && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.primary_contact.phone_numbers[index].number.message}
                    </p>
                )}
                
              </div>
              <div>
                <input
                  type="text"
                  {...register(`primary_contact.phone_numbers[${index}].ext`)}
                  
                  className={`${inputClassName} ${errors.primary_contact?.phone_numbers?.[index]?.ext ? 'border-red-500' : ''}`}
                  placeholder="Extension"
                />
                {errors.primary_contact?.phone_numbers?.[index]?.ext && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.primary_contact.phone_numbers[index].ext.message}
                    </p>
                )}
              </div>
              <div className="flex items-center">
                <button
                  type="button"
                  onClick={() => removePhoneNumber(index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <TrashIcon className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Emails */}
        <div className="mt-6">
          <div className="flex justify-between items-center ">
            <label className="block text-sm font-medium text-gray-700 mb-1">Email Addresses <span className="text-red-500">*</span></label>
            <button
              type="button"
              onClick={addEmail}
              className="flex items-center px-3 py-1 text-sm text-[#009efb] hover:text-[#0089db]"
            >
              <PlusIcon className="w-4 h-4 mr-1" />
              Add Email
            </button>
          </div>
          {errors.primary_contact?.emails && typeof errors.primary_contact.emails === 'string' && (
            <p className="mt-1 text-sm text-red-600 mb-4">{errors.primary_contact.emails}</p>
          )}
          {watchEmails.map((email, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div>
                <Select
                  options={emailTypeOptions}
                  {...register(`primary_contact.emails[${index}].type`)}
                  value={emailTypeOptions.find(option => option.value === email.type)}  
                  onChange={(option) => {
                    const updatedEmails = [...watchEmails];
                    updatedEmails[index].type = option?.value || '';
                    setValue('primary_contact.emails', updatedEmails);
                  }}
                  
                  placeholder="Type"
                />
                
                  {errors.primary_contact?.emails?.[index]?.type && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.primary_contact.emails[index].type.message}
                    </p>
                )}
              </div>
            
              <div className="relative">
              <input
                    type="email"
                    {...register(`primary_contact.emails[${index}].address`)}
                    
                    placeholder="Enter email address"
                    className={`${inputClassName} ${errors.primary_contact?.emails?.[index]?.address ? 'border-red-500' : ''} ${email.address && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.address) ? 'border-green-500' : ''}`}
                    />
                {email.address && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.address) && (
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
                {errors.primary_contact?.emails?.[index]?.address && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.primary_contact.emails[index].address.message}
                    </p>
                )}
              </div>
              <div className="flex items-center">
                <button
                  type="button"
                  onClick={() => removeEmail(index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <TrashIcon className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Options */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('primary_contact.is_billing_contact')}
              className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Billing Contact
            </label>
          </div>

          <div className="flex items-center">
            <input
              type="checkbox"
              {...register('primary_contact.is_booking_contact')}
              className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Booking Contact
            </label>
          </div>
        </div>

        {/* Personal Dates */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Birthday
            </label>
            <input
              type="text"
              {...register('primary_contact.birthday')}
              onInput={(e) => {
                setValue('primary_contact.birthday', e.target.value);
                
              }}
             placeholder="Enter Birthday"
              className={`${inputClassName} ${errors.primary_contact?.birthday ? 'border-red-500' : ''} datepicker`}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Anniversary
            </label>
            <input
              type="text"
              {...register('primary_contact.anniversary')}
              onInput={(e) => {
                setValue('primary_contact.anniversary', e.target.value);
                
              }}
              placeholder="Enter Anniversary"
              className={`${inputClassName} ${errors.primary_contact?.anniversary ? 'border-red-500' : ''} datepicker`}
            />
          </div>
        </div>
      </div>

      {/* Service Locations */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Service Locations</h3>
          <button
            type="button"
            onClick={addServiceLocation}
            className="flex items-center px-3 py-1 text-sm text-[#009efb] hover:text-[#0089db]"
          >
            <PlusIcon className="w-4 h-4 mr-1" />
            Add Location
          </button>
        </div>
       
        {watchServiceLocations.map((location, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-4 mb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Location Nickname <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].location_nickname`)}
                  
                  onChange={(e) => {
                    if(e.target.value === ''){
                      setError(`service_locations[${index}].location_nickname`, {
                        type: 'required',
                        message: 'Location nickname is required'
                      });
                    }else{
                      clearErrors(`service_locations[${index}].location_nickname`);
                    }
                    setValue(`service_locations[${index}].location_nickname`, e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.location_nickname ? 'border-red-500' : ''}`}
                  placeholder="Enter location nickname"
                />
              
                {errors.service_locations?.[index]?.location_nickname && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].location_nickname.message}
                    </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Street Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].street_address`)}
                   
                  onChange={(e) => {
                      if(e.target.value === ''){
                        setError(`service_locations[${index}].street_address`, {
                          type: 'required',
                          message: 'Street address is required'
                        });
                      }else{
                        clearErrors(`service_locations[${index}].street_address`);
                      }
                    setValue(`service_locations[${index}].street_address`, e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.street_address ? 'border-red-500' : ''}`}
                  placeholder="Enter street address"
                />
                {errors.service_locations?.[index]?.street_address && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].street_address.message}
                    </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Apt/Suite/Unit
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].apt`)}
                  
                  onChange={(e) => {
                    if(e.target.value === ''){
                      setError(`service_locations[${index}].apt`, {
                        type: 'required',
                        message: 'Apt is required'
                      });
                    }else{
                      clearErrors(`service_locations[${index}].apt`);
                    }
                    setValue(`service_locations[${index}].apt`, e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.apt ? 'border-red-500' : ''}`}
                  placeholder="Enter apt/suite/unit"
                />
                {errors.service_locations?.[index]?.apt && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].apt.message}
                    </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  City <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].city`)}
                  
                  onChange={(e) => {
                    if(e.target.value === ''){
                      setError(`service_locations[${index}].city`, {
                        type: 'required',
                        message: 'City is required'
                      });
                    }else{
                      clearErrors(`service_locations[${index}].city`);
                    }
                    setValue(`service_locations[${index}].city`, e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.city ? 'border-red-500' : ''}`}
                  placeholder="Enter city"
                />
                {errors.service_locations?.[index]?.city && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].city.message}
                    </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State/Province <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].state`)}
                   
                  onChange={(e) => {
                    if(e.target.value === ''){
                      setError(`service_locations[${index}].state`, {
                        type: 'required',
                        message: 'State is required'
                      });
                    }else{
                      clearErrors(`service_locations[${index}].state`);
                    }
                    setValue(`service_locations[${index}].state`, e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.state ? 'border-red-500' : ''}`}
                  placeholder="Enter state/province"
                />
                {errors.service_locations?.[index]?.state && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].state.message}
                    </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  ZIP/Postal Code <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  {...register(`service_locations[${index}].zipcode`)}
                  
                  onChange={(e) => {
                    if(e.target.value === ''){
                      setError(`service_locations[${index}].zipcode`, {
                        type: 'required',
                        message: 'ZIP/Postal code is required'
                      });
                    }else{
                      clearErrors(`service_locations[${index}].zipcode`);
                    }
                    setValue(`service_locations[${index}].zipcode`,  e.target.value);
                  }}
                  className={`${inputClassName} ${errors.service_locations?.[index]?.zipcode ? 'border-red-500' : ''}`}
                  placeholder="Enter ZIP/postal code"
                />
                {errors.service_locations?.[index]?.zipcode && (
                    <p className="mt-1 text-sm text-red-600">
                        {errors.service_locations[index].zipcode.message}
                    </p>
                )}
              </div>
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register(`service_locations[${index}].is_primary_location`)}
                  onChange={(e) => {
                   
                    setValue(
                      `service_locations[${index}].is_primary_location`,
                      e.target.checked
                    );
                  }}
                  className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
                />
                <label className="ml-2 block text-sm text-gray-900">
                  Primary Location
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register(`service_locations[${index}].is_billing_address`)}
                  
                  onChange={(e) => {
                  
                    setValue(
                      `service_locations[${index}].is_billing_address`,
                      e.target.checked
                    );
                  }}
                  className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
                />
                <label className="ml-2 block text-sm text-gray-900">
                  Billing Address
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register(`service_locations[${index}].is_gated_property`)}
                  
                  onChange={(e) => {
                    
                    setValue(
                      `service_locations[${index}].is_gated_property`,
                      e.target.checked
                    );
                  }}
                  className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
                />
                <label className="ml-2 block text-sm text-gray-900">
                  Gated Property
                </label>
              </div>

              <div className="flex items-center">
                <input
                  type="checkbox"
                  {...register(`service_locations[${index}].active`)}
                   
                  onChange={(e) => {
                    
                    setValue(
                      `service_locations[${index}].active`,
                      e.target.checked
                    );
                  }}
                  className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
                />
                <label className="ml-2 block text-sm text-gray-900">
                  Active
                </label>
              </div>
            </div>

            {watch(`service_locations[${index}].is_gated_property`) === true && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Gate Access Instructions
                </label>
                <textarea
                  {...register(`service_locations[${index}].gate_access_instructions`)}
                 
                  onChange={(e) => {
                    
                    setValue(`service_locations[${index}].gate_access_instructions`, e.target.value);
                  }}
                  className={inputClassName}
                  rows="3"
                  placeholder="Enter gate access instructions"
                />
              </div>
            )}

            <div className="mt-4 flex justify-end">
              <button
                type="button"
                onClick={() => removeServiceLocation(index)}
                className="text-red-600 hover:text-red-800"
              >
                <TrashIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Information */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Referral Source
            </label>
            <Select
            {...register('referral_source_id')}
            
              options={
                [
                  { value: '', label: 'Select Referral Source' },
                  ...getReferralSources?.map(option => ({
                    value: option.id,
                    label: option.name
                  }))
                ]}
                value={
                  // match the selected value with the options list
                  [
                    { value: '', label: 'Select Referral Source' },
                    ...getReferralSources?.map(option => ({
                      value: option.id,
                      label: option.name
                    }))
                  ].find(opt => opt.value === watch('referral_source_id'))
                }
              onChange={(option) => setValue('referral_source_id', option?.value || '')}
              styles={customStyles}
              placeholder="Select referral source"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Industry
            </label>
            <Select
            {...register('industry_id')}
            options={[
              { value: '', label: 'Select Industry' },
              ...getIndustries?.map(option => ({
                value: option.id,
                label: option.name
              }))
            ]}
            value={
              // match the selected value with the options list
              [
                { value: '', label: 'Select Industry' },
                ...getIndustries?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ].find(opt => opt.value === watch('industry_id'))
            }
              onChange={(option) => setValue('industry_id', option?.value || '')}
              styles={customStyles}
              placeholder="Select industry"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Assigned Contract
            </label>
            <Select
            {...register('assigned_contract_id')}
            options={[
              { value: '', label: 'Select Assigned Contract' },
              ...getAssignedContracts?.map(option => ({
                value: option.id,
                label: option.name
              }))
            ]}
            value={
              // match the selected value with the options list
              [
                { value: '', label: 'Select Assigned Contract' },
                ...getAssignedContracts?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ].find(opt => opt.value === watch('assigned_contract_id'))
            }
              onChange={(option) => setValue('assigned_contract_id', option?.value || '')}
              styles={customStyles}
              placeholder="Select contract"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Business Number/Tax ID
            </label>
            <input
              type="text"
              {...register('tax_id')}
              className={inputClassName}
              placeholder="Enter business number/tax ID"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Default Currency
            </label>
            <Select
              {...register('default_currency_id')}
              options={[
                { value: '', label: 'Select Currency' },
                ...getCurrencies?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ]}
              value={
                // match the selected value with the options list
                [
                  { value: '', label: 'Select Currency' },
                  ...getCurrencies?.map(option => ({
                    value: option.id,
                    label: option.name
                  }))
                ].find(opt => opt.value === watch('default_currency_id'))
              }
              onChange={(option) => setValue('default_currency_id', option?.value || '')}
              styles={customStyles}
              placeholder="Select currency"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tax Item
            </label>
            <Select
            {...register('tax_item_id')}
              options={[
                { value: '', label: 'Select Tax Item' },
                ...getTaxItems?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ]}
              value={
                // match the selected value with the options list
                [
                  { value: '', label: 'Select Tax Item' },
                  ...getTaxItems?.map(option => ({
                    value: option.id,
                    label: option.name
                  }))
                ].find(opt => opt.value === watch('tax_item_id'))
              }
              onChange={(option) => setValue('tax_item_id', option?.value || '')}
              styles={customStyles}
              placeholder="Select tax item"
            />
          </div>
        </div>

        <div className="mt-4 flex items-center">
          <input
            type="checkbox"
            {...register('is_taxable')}
            className="h-4 w-4 text-[#009efb] focus:ring-[#009efb] border-gray-300 rounded"
          />
          <label className="ml-2 block text-sm text-gray-900">
            Taxable
          </label>
        </div>
      </div>

      {/* Notes */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Notes</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Internal/Private Notes
            </label>
            <textarea
              {...register('private_notes')}
              className={inputClassName}
              rows="4"
              placeholder="Enter internal/private notes"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Public Work Order Notes
            </label>
            <textarea
              {...register('order_notes')}
              className={inputClassName}
              rows="4"
              placeholder="Enter public work order notes"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Tags
            </label>
             
            <Select
              isMulti
              isSearchable
              options={[
                { value: '', label: 'Select Customer Tags', isDisabled: true },
                ...getCustomerTags?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ]}
              value={
                // Convert selected values (ids) from watch to full option objects
                getCustomerTags
                  ?.filter(tag => (watch('customer_tag_ids') || []).includes(tag.id))
                  .map(tag => ({
                    value: tag.id,
                    label: tag.name
                  }))
              }
              onChange={(selectedOptions) => {
                const selectedTags = selectedOptions
                  ? selectedOptions
                      .map(option => option.value)
                      .filter(value => value !== '') // remove empty value
                  : [];

                setValue('customer_tag_ids', selectedTags);
              }}
              classNamePrefix="react-select"
              placeholder="Select customer tags..."
            />

 
          </div>
        </div>
      </div>
 
      {/* Assigned Agents/Reps */}
      <div className="bg-gray-50 p-6 rounded-lg">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Assigned Agents/Reps</h3>
          <button
            type="button"
            onClick={addAgentRep}
            className="flex items-center px-3 py-1 text-sm text-[#009efb] hover:text-[#0089db]"
          >
            <PlusIcon className="w-4 h-4 mr-1" />
            Add Agent/Rep
          </button>
        </div>
        {watchAssignedAgentsReps.map((agent, index) => (
          <div key={index} className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
            <div>
              <Select
              {...register(`assigned_agents[${index}].agent_rep_id`)}
              options={[
                { value: '', label: 'Select Agent/Rep' },
                ...getAssignedAgents?.map(option => ({
                  value: option.id,
                  label: option.name
                }))
              ]}
              value={
                // match the selected value with the options list
                [
                  { value: '', label: 'Select Agent/Rep' },
                  ...getAssignedAgents?.map(option => ({
                    value: option.id,
                    label: option.name
                  }))
                ].find(opt => opt.value === watch(`assigned_agents[${index}].agent_rep_id`))
              }
                onChange={(option) => {
                   
                  setValue(`assigned_agents[${index}].agent_rep_id`, option?.value || '');
                }}
                styles={customStyles}
                placeholder="Select agent/rep"
              />
            </div>
            <div>

            <Select
                {...register(`assigned_agents[${index}].commission_type`)}
              options={[
                { value: '', label: 'Select Commission Type' },
                ...getCommissionTypes?.map(option => ({
                  value: option.value,
                  label: option.label
                }))
              ]}
              value={
                // match the selected value with the options list
                [
                  { value: '', label: 'Select Commission Type' },
                  ...getCommissionTypes?.map(option => ({
                    value: option.value,
                    label: option.label
                  }))
                ].find(opt => opt.value === watch(`assigned_agents[${index}].commission_type`))
              }
                onChange={(option) => {
                   
                  setValue(`assigned_agents[${index}].commission_type`, option?.value || '');
                }}
                styles={customStyles}
                placeholder="Select commission type"
              />
 
            </div>
            <div>
              <input
                 type="number"
                {...register(`assigned_agents[${index}].commission`)}
               
                onChange={(e) => {
                  
                  setValue(`assigned_agents[${index}].commission`, e.target.value);
                }}
                className={inputClassName}
                placeholder="Custom commission"
              />
            </div>
            <div className="flex items-center">
              <button
                type="button"
                onClick={() => removeAgentRep(index)}
                className="text-red-600 hover:text-red-800"
              >
                <TrashIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountInfoTab; 